module.exports = __webpack_public_path__ + "img/doms.913a2719.png";